import React from 'react';
import SearchBlock from '../SearchBlock';
import { GoArrowRight } from 'react-icons/go';
import { GoArrowLeft } from 'react-icons/go';
import iconTube from '../../assets/icon-test-tube.svg';
import iconExport from '../../assets/icon-export.svg';
import { AgentChatStyled, DeepSearhCol, IdeasWrap } from './AgentChatBlock.styles';

const ideaData = [
  {
    title: 'Analyze evolution of LLMs for work',
  },
  {
    title: 'Review CRISPR medical impact',
  },
  {
    title: 'Map superhero VFX evolution',
  },
  {
    title: 'Track trading algorithm trends',
  },
];

const AgentChatBlock = () => {
  return (
    <>
      <AgentChatStyled>
        <a href="/" className="btn-back">
          <GoArrowLeft size="18" /> Back to Home
        </a>
        <DeepSearhCol>
          <div className="img-box">
            <img src={iconTube} alt="img" />
          </div>
          <div className="text-box">
            <strong className="title">Research</strong>
            <p>Deep research with industry-leading accuracy.</p>
            <a className="learn-more" href="/">
              By Feedaaia.com
            </a>
          </div>
          <button type="button" className="btn-export">
            <img src={iconExport} alt="img" />
          </button>
        </DeepSearhCol>
        <SearchBlock />
        <div className="ideas-wrap">
          <span className="title">Need ideas? Try these</span>
          <IdeasWrap>
            {ideaData.map((item, index) => (
              <button type="button" className="idea-card" key={index}>
                <strong className="title">{item.title}</strong>
                <GoArrowRight className="ico-arrow" />
              </button>
            ))}
          </IdeasWrap>
        </div>
      </AgentChatStyled>
    </>
  );
};

export default AgentChatBlock;
